import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { useTranslation } from 'react-i18next';

// Company Logos
import group7 from '../assets/img/companies/Group-7-1.png'
import humming from '../assets/img/companies/cropped-Humming_logo_3-removebg-preview.png'
import eon from '../assets/img/companies/eon-logo-blanco-768x388.png'
import iwalkwithu from '../assets/img/companies/iwalkwithu-logo.webp'
import ranko from '../assets/img/companies/logo-ranko-positivo.png'
import mercantil from '../assets/img/companies/mercantil-Logo.svg'
import raulito from '../assets/img/companies/raulito-logo-01-scaled-e1748369698821.png'
import trompo from '../assets/img/companies/trompo-logo-black.webp'
import wehost from '../assets/img/companies/wehost-logo.png'

// SVGR Error Workaround for Kore logo
const kore = "/assets/img/companies/kore-svg-letras-blancas.svg";


function Experience() {
    const { t } = useTranslation();
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            item: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    const companies = [
        { img: group7, alt: "Volvo", url: "https://ahoramasvolvo.com.ar" },
        { img: humming, alt: "Humming", url: "https://humminghomeservices.au" },
        { img: eon, alt: "Eon", url: "https://grupoeon.com.ar" },
        { img: iwalkwithu, alt: "I Walk With U", url: "https://iwalkwithu.com/inicio" },
        { img: kore, alt: "Kore", url: "https://korestudio.com.ar" },
        { img: ranko, alt: "Ranko", dark: true, url: "https://tienda.ranko.com.ar" },
        { img: mercantil, alt: "Mercantil", url: "https://www.mercantilandina.com.ar" },
        { img: raulito, alt: "Raulito", url: "https://productosraulito.com.ar" },
        { img: trompo, alt: "Trompo", dark: true, url: "https://trompoagencia.com" },
        { img: wehost, alt: "WeHostBsAs", dark: true, url: "https://wehostbsas.com" },
    ];

    return (
        <section className="experience" id="experience">
            <Container>
                <Row>
                    <Col>
                        <div className="experience-bx">
                            <h2>
                                {t('experience.title')}
                            </h2>
                            <p> {t('experience.description')}</p>
                            <Carousel responsive={responsive} infinite={true} autoPlay={true} autoPlaySpeed={3000} className="experience-slider">
                                {companies.map((company, index) => (
                                    <div className="item" key={index}>
                                        <div className="company-logo-container">
                                            <a href={company.url} target="_blank" rel="noopener noreferrer">
                                                <img
                                                    src={company.img}
                                                    alt={company.alt}
                                                    className={`company-logo ${company.dark ? 'dark-logo' : ''}`}
                                                    width="120" height="60" loading="lazy"
                                                />
                                            </a>
                                        </div>
                                    </div>
                                ))}
                            </Carousel>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Experience
